import styled, { css } from 'styled-components'
import { minmedia } from '../../styles/media-queries'
import { Input } from '../../styles/defaults'
import { bordergray, white, whitegray, red, black, inputgray, darkgray } from '../../styles/colors'

export const Wrap = styled.div`
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`

export const InputContainer = styled.div`
  position: relative;
`

export const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  color: ${darkgray};
`

export const StyledInput = Input.extend`
  padding-left: ${props => (props.icon ? '2.5rem' : '1rem')};
  ${props =>
    props.valid === false &&
    css`
      border-color: ${red};
      box-shadow: 0px 0px 5px 0px ${red};
      &:focus {
        border-color: ${red};
        box-shadow: 0px 0px 5px 0px ${red};
      }
    `};
`

export const StyledTextArea = styled.textarea`
  transition: all 0.5s;
  padding: 0.75rem 1rem;
  font-weight: 300;
  font-size: 18px;
  background: ${whitegray};
  border: 1px solid ${bordergray};
  border-radius: 0.25rem;
  color: ${black};
  display: inline-block;
  width: 100%;
  resize: vertical;
  height: 7rem;
  ${minmedia.medium`
    font-size: 18px;
    height: 10rem;
  `} &:focus {
    border-color: ${inputgray};
    box-shadow: 0px 0px 5px 0px ${inputgray};
    outline: none;
  }

  &::-webkit-input-placeholder {
    color: ${inputgray};
  }
  &::-moz-placeholder {
    color: ${inputgray};
    opacity: 1;
  }
  &:-ms-input-placeholder {
    color: ${inputgray};
  }

  ${props =>
    props.valid === false &&
    css`
      border-color: ${red};
      box-shadow: 0px 0px 5px 0px ${red};
      &:focus {
        border-color: ${red};
        box-shadow: 0px 0px 5px 0px ${red};
      }
    `};
`

export const IconContainer = styled.div`
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  width: 1rem;
  height: 1rem;

  svg {
    width: 1rem;
    height: 1rem;
    fill: ${inputgray};
  }
`

export const Button = styled.div`
  transition: all 0.5s;
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  padding: 0.25rem 0.6rem;
  cursor: pointer;

  font-size: 14px;
  color: ${white};
  background: ${bordergray};
  border-radius: 0.25rem;
  font-family: 'Helvetica', sans-serif;
  text-align: center;
  user-select: none;

  &:hover {
    background: ${inputgray};
  }
`



// WEBPACK FOOTER //
// ./src/components/Input/styles.js